import * as React from 'react';

import styles from './index.module.css';
import defaultStyles from '../../styles/formSetStyles.module.css';

import InputAdornment from '@material-ui/core/InputAdornment';

import { TextInput } from '../TextInput';
import { ModalContainer } from '../ModalContainer';

interface Props {
  id?: string;
  children: React.ReactNode;
  initialValue?: string;
  disabled?: boolean;
  isOpen: boolean;
  setIsOpen: (newState: boolean) => void;
  setCurrentText?: (newText: string) => void;
  placeholder: string;
  startIcon?: React.ReactNode;
  endIcon?: React.ReactNode;
  onModalClose: () => void;
  modalTitle?: string;
  header?: boolean;
}

export const ModalInput: React.FC<Props> = (props) => {
  const [shouldOpenOnFocus, setShouldOpenOnFocus] = React.useState(true);

  const renderInput = () => {
    const {
      id,
      placeholder,
      setIsOpen,
      setCurrentText,
      startIcon,
      endIcon,
      initialValue,
      disabled = false,
    } = props;

    const openModal = () => setIsOpen(true);
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
      // Capture whatever the patient just typed in and pass it on to the modal
      const { value } = event.target;
      if (setCurrentText !== undefined) {
        setCurrentText(value);
      }
      openModal();
    };

    return (
      <TextInput
        tabIndex={0}
        id={id}
        onFocus={() => {
          if (disabled) return;
          // When closing the modal returns focus to the input, that shouldn't reopen the modal
          if (!shouldOpenOnFocus) return;
          setShouldOpenOnFocus(false);
          openModal();
        }}
        onBlur={() => {
          if (props.isOpen) return;
          setShouldOpenOnFocus(true);
        }}
        onClick={() => {
          if (disabled) return;
          openModal();
        }}
        onChange={handleChange}
        className={defaultStyles.CanBeDisabled}
        placeholder={placeholder}
        value={initialValue}
        disabled={disabled}
        InputProps={{
          ...(startIcon
            ? {
                startAdornment: (
                  <InputAdornment position="start">{startIcon}</InputAdornment>
                ),
              }
            : {}),
          ...(endIcon
            ? {
                endAdornment: (
                  <InputAdornment
                    position="end"
                    className={styles.InputAdornmentEnd}
                  >
                    {endIcon}
                  </InputAdornment>
                ),
              }
            : {}),
        }}
      />
    );
  };

  const renderModal = () => {
    const { children, isOpen, onModalClose, modalTitle, header } = props;

    return (
      <ModalContainer
        isOpen={isOpen}
        onModalClose={onModalClose}
        topLabel={modalTitle}
        header={header}
      >
        {children}
      </ModalContainer>
    );
  };

  return (
    <div>
      {renderInput()}
      {renderModal()}
    </div>
  );
};
